import type { TranslationTree } from '../../types';

export const layout: TranslationTree = {
  header: {
    menuToggle: 'Open navigation menu',
    settingsTooltip: 'Settings',
  },
  sidebar: {
    traceability: 'Tool View',
    analytics: 'Analytics',
    ml: 'Machine Learning',
    labelize: 'Labeling',
    admin: 'Admin',
    backendConfig: 'Backend config',
    toolRecommender: 'Tool Eco-Design',
    workshop: 'Workshop',
    profile: 'Profile',
    collapse: 'Collapse',
    expand: 'Expand',
    disconnect: 'Disconnect',
    mobileNavigation: 'Mobile navigation',
    desktopNavigation: 'Desktop navigation',
  },
  quickAccess: {
    traceability: 'Traceability',
  },
  avatarMenu: {
    language: 'Language',
    profile: 'Profile',
    logout: 'Log out',
    ariaLabel: 'User menu',
  },
  footer: {
    exploreLink: 'Visit Louis Bélet',
    contactSupport: 'Contact support',
    rights: 'All rights reserved.',
  },
};
